import React from 'react';
import { useIntl } from 'react-intl';

const AcceptedTermsOfServiceListHeader = () => {
  const intl = useIntl();

  return (
    <tr>
      <th>
        {intl.formatMessage({ defaultMessage: 'IP address' })}
      </th>
      <th>
        {intl.formatMessage({ defaultMessage: 'Date' })}
      </th>
    </tr>
  );
};

export default AcceptedTermsOfServiceListHeader;
